// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__8h3PA","imgContainer":"styles_imgContainer__ctcK4","img":"styles_img__FplTt"};